import * as React from 'react'
import { cn } from '@/lib/utils'

const Card = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div data-upbo-src="src/components/ui/card.tsx:5" data-slot="card" className={cn('flex flex-col gap-6 rounded-xl border bg-card py-6 text-card-foreground shadow-sm', className)} {...props} />
)
const CardHeader = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div data-upbo-src="src/components/ui/card.tsx:8" data-slot="card-header" className={cn('flex flex-col gap-1.5 px-6', className)} {...props} />
)
const CardTitle = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div data-upbo-src="src/components/ui/card.tsx:11" data-slot="card-title" className={cn('leading-none font-semibold', className)} {...props} />
)
const CardDescription = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div data-upbo-src="src/components/ui/card.tsx:14" data-slot="card-description" className={cn('text-sm text-muted-foreground', className)} {...props} />
)
const CardContent = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div data-upbo-src="src/components/ui/card.tsx:17" data-slot="card-content" className={cn('px-6', className)} {...props} />
)
const CardFooter = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div data-upbo-src="src/components/ui/card.tsx:20" data-slot="card-footer" className={cn('flex items-center px-6', className)} {...props} />
)

export { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter }
